function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebService({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "9.59 15.16 10.33 14.42 10.08 13.64 9.59 15.16",
    style: {
      fill: "#3b7ff5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.12,3.28h-.19a6.22,6.22,0,0,0-6.7,5.32H6.07A6.08,6.08,0,0,0,4.28,20.48l4.2-4.21H8.13l-.31-1L6.64,11.73H8l.78,2.76.81-2.76h1l.3,1,.25.86.72-.71.33-1.16H13l5.22-5.22A6.64,6.64,0,0,0,13.12,3.28Z",
    style: {
      fill: "#3b7ff5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.87 12.89 11.15 13.6 11.41 14.49 11.87 12.89",
    style: {
      fill: "#4d94ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.19,10.49V9.9a6.61,6.61,0,0,0-.94-3.39L13,11.73h.5L12,16.27h-1.1l-.6-1.85-.74.74-.35,1.11H8.48l-4.2,4.21a6.08,6.08,0,0,0,1.82.28H18.87A5.13,5.13,0,0,0,24,15.63v-.32A4.81,4.81,0,0,0,19.19,10.49ZM15.54,16.4a2.41,2.41,0,0,1-1.82-.78l.72-.74a1.38,1.38,0,0,0,1,.48.53.53,0,0,0,.59-.48c0-.62-2.12-.3-2.12-1.89a1.57,1.57,0,0,1,1.73-1.39,2,2,0,0,1,1.59.64l-.71.75a1.07,1.07,0,0,0-.75-.36.45.45,0,0,0-.49.39c0,.62,2.11.3,2.11,1.89C17.36,15.72,16.68,16.4,15.54,16.4Z",
    style: {
      fill: "#4d94ff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebService);
export default __webpack_public_path__ + "static/media/web-service.10b90ace260184a37a19156d47fff9d9.svg";
export { ForwardRef as ReactComponent };